export default __webpack_public_path__ + "static/media/SourceSansPro-BoldItalic.097e86e5.woff";